import React from "react";
import { useAuth } from "./useAuth";
import PageContainer from "components/PageContainer/PageContainer";

const Authorization = ({ type, rolePermission, children }) => {
  const { user, logout } = useAuth();
  const { uiPermissions } = user;
  const session = JSON.parse(localStorage.getItem("session"));
  const token = session ? session.token : null;
  if (!token) {
    return logout("LOGOUT");
  }
  const localStoragePermission = session.isoAgent.uiPermissions ?? [];

  if (type === "accordion") {
    return rolePermission !== 0 ? children : null;
  }

  if (type === "page") {
    if (user?.role === "SUPER_ADMIN") {
      return children;
    }

    const allowed =
      rolePermission == "" ||
      uiPermissions.includes(rolePermission) ||
      localStoragePermission.includes(rolePermission);
    return allowed ? children : <PageContainer unauthorized />;
  }
};

export default Authorization;
